import { useState } from 'react';
import { Box, Grid, TextField, Button as PriButton, InputAdornment, IconButton, FormControl, InputLabel } from "@mui/material"
import {
  Body,
} from "../../screens/Login/Login.styles"
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PasswordPolicy from "../../components/PasswordPolicy/PasswordPolicy";
import Button from "../../components/Button/Button"

export default function ResetPassword({password, handleCurPwdChange, newPassword, handleNewPwdChange, confPassword, handleConfirmPwdChange, handleCancelClick, resetPwdMutation, errCurrPwd, errNewPwd, errConfPwd}) {
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleTogglePassword = () => setShowPassword((show) => !show);
    const lineStyle = {
        width: '1px',
        height: '480px',
        backgroundColor: '#e2dedeff',
        margin: '8px 40px 8px 40px',
    };

    
    return(
        <Box sx={{display: 'flex', flexDirection: "row", width: '100%', margin: '0 auto', minHeight: `calc(100vh - 320px)`}}>
            <Box  sx={{width: '49%', margin: '0 auto', display: 'inline-flex', flexDirection: 'column'}}>
                <Body sx={{fontSize: '18px', color: "#000", mb:0}}>
                    Reset password
                </Body>
                <Body sx={{fontSize: '12px', color: "#000"}}>
                    *All fields are mandatory
                </Body>
                <Box>
                    <Grid sx={{ marginBottom: '20px',}}>
                        <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                        >
                        <TextField
                            type={showPassword ? "text" : "password"}
                            label={"Enter old password"}
                            value={password}
                            name="currPwd"
                            onChange={handleCurPwdChange}
                            fullWidth
                            required
                            error={!!errCurrPwd}
                            helperText={errCurrPwd}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    onClick={handleTogglePassword}
                                    edge="end"
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                                ),
                                sx: {
                                backgroundColor: 'white'
                                }
                            }}
                        />
                        </FormControl>
                    </Grid>
                    <Grid sx={{ marginBottom: '20px',}}>
                        <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                        >
                        <TextField
                            type={showPassword ? "text" : "password"}
                            label={"Enter new password"}
                            value={newPassword}
                            name="newPwd"
                            onChange={handleNewPwdChange}
                            fullWidth
                            required
                            error={!!errNewPwd}
                            helperText={errNewPwd}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    onClick={handleTogglePassword}
                                    edge="end"
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                                ),
                                sx: {
                                backgroundColor: 'white'
                                }
                            }}
                        />
                        </FormControl>
                    </Grid>
                    <Grid sx={{ marginBottom: '20px', }}>
                        <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                        >
                        <TextField
                            type={showPassword ? "text" : "password"}
                            label={"Confirm new password"}
                            value={confPassword}
                            name="confNewPwd"
                            onChange={handleConfirmPwdChange}
                            fullWidth
                            required
                            error={!!errConfPwd}
                            helperText={errConfPwd}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                    onClick={handleTogglePassword}
                                    edge="end"
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                                ),
                                sx: {
                                backgroundColor: 'white'
                                }
                            }}
                        />
                        </FormControl>
                    </Grid>
                <Grid sx={{ marginBottom: '20px', }}>
                    <Button
                        color={"--navy"}
                        colorSecondary={"--grey-grey-08"}
                        variant="outlined"
                        onClick={handleCancelClick}
                        sx={{marginRight: '20px', width: '46%'}}
                        label="Cancel"
                    />
                    <PriButton
                        type="button"
                        onClick={resetPwdMutation}
                        variant="contained"
                        sx={{
                            backgroundColor: 'var(--brand-default-color)',
                            color: '#fff',
                            textTransform: 'none',
                            borderRadius: '20px',
                            padding: '8px 24px',
                            width: '46%'
                        }}
                        disabled={resetPwdMutation.isPending}
                    >
                        {resetPwdMutation.isPending? "Loading..." : "Save"}
                    </PriButton>
                    </Grid>
                </Box>
            </Box>
            <div style={lineStyle}></div>
            <Box sx={{ display: 'inline-flex', width: '40%' }}>
                <PasswordPolicy password={newPassword} />
            </Box>
        </Box>
    );
}


